// // action - state management
// import { REGISTER, LOGIN, LOGOUT } from './actions';

// // types
// import { AuthProps, AuthActionProps } from 'types/auth';

// // initial state
// export const initialState: AuthProps = {
//   isLoggedIn: false,
//   isInitialized: false,
//   user: null,
//   permissions: []

// };

// // ==============================|| AUTH REDUCER ||============================== //

// const auth = (state = initialState, action: AuthActionProps) => {
//   switch (action.type) {
//     case REGISTER: {
//       const { user } = action.payload!;
//       return {
//         ...state,
//         user
//       };
//     }
//     case LOGIN: {
//       const { user } = action.payload!;
//       return {
//         ...state,
//         isLoggedIn: true,
//         isInitialized: true,
//         user
//       };
//     }
//     case LOGOUT: {
//       return {
//         ...state,
//         isInitialized: true,
//         isLoggedIn: false,
//         user: null
//       };
//     }
//     default: {
//       return { ...state };
//     }
//   }
// };

// export default auth;
// action - state management
import { REGISTER, LOGIN, LOGOUT } from './actions';

// types
import { AuthProps, AuthActionProps } from 'types/auth';

// initial state
export const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  permissions: []
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state: AuthProps = initialState, action: AuthActionProps): AuthProps => {
  switch (action.type) {
    case REGISTER: {
      const { user, permissions = [] } = action.payload!;
      return {
        ...state,
        user,
        permissions
      };
    }

    case LOGIN: {
      const { user, permissions = [] } = action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        permissions
      };
    }

    case LOGOUT: {
      return {
        ...initialState,
        isInitialized: true
      };
    }

    default:
      return state;
  }
};

export default auth;

